import React from 'react';

import { getBreakPoints } from '../../Hub/HubUtils';
import { FromAccounts, ToAccount, Totals } from './ConfirmationTableCells';
import './ConfirmationTable.scss';

const ConfirmationTable = ({agreementsGroupByType}) =>
<>
  {getBreakPoints('sm') ? (
    <table className='transfer-confirmation-table'>
      <tr>
        <th><div>From:</div></th>
        <th><div>To:</div></th>
        <th><div>Amount:</div></th>
      </tr>
      {agreementsGroupByType.map(agreementGroup =>
        agreementGroup.agreements.some(agreement => agreement.isTransfer) ?
          <tr>
            <td>
              <FromAccounts agreementGroup={agreementGroup} />
            </td>
            <td>
              <ToAccount agreementGroup={agreementGroup} />
            </td>
            <td>
              <Totals agreementGroup={agreementGroup} />
            </td>
          </tr>
          : null
      )}
    </table>
  ) : (
    <div style={{padding: '24px 32px'}}>
      {agreementsGroupByType.map(agreementGroup =>
        agreementGroup.agreements.some(agreement => agreement.isTransfer) ?
          <>
          <div style={{paddingBottom: '32px'}}>
            <div style={{fontSize: '16px', lineHeight: '24px', paddingBottom: '8px', marginBottom: '16px', borderBottom: '1px solid gray'}}>From:</div>
            <FromAccounts agreementGroup={agreementGroup} />
          </div>
          <div style={{paddingBottom: '32px'}}>
            <div style={{fontSize: '16px', lineHeight: '24px', paddingBottom: '8px', marginBottom: '16px', borderBottom: '1px solid gray'}}>To:</div>
            <ToAccount agreementGroup={agreementGroup} />
          </div>
          <div>
            <div style={{fontSize: '16px', lineHeight: '24px', paddingBottom: '8px', marginBottom: '16px', borderBottom: '1px solid gray'}}>Amount:</div>
            <Totals agreementGroup={agreementGroup} />
          </div>
          </>
          : null
      )}
    </div>
  )}
</>;

export default ConfirmationTable;
